module.exports = __webpack_public_path__ + "img/result_title.bd09b4cd.png";